import { render, staticRenderFns } from "./ContentFeedItemMenu.vue?vue&type=template&id=0d0eb4e4&"
import script from "./ContentFeedItemMenu.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedItemMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports